import * as Sentry from '@sentry/nextjs';

import type { SoftphoneDiagnostic } from '@poseidon/components/Softphone/softphoneClient.types';
import { buildSoftphoneReport } from '@poseidon/components/Softphone/softphoneDiagnosticReport';

/**
 * The dashboard's softphone diagnostic sink: hand each diagnostic to Sentry the way the shared
 * `buildSoftphoneReport` decides (breadcrumb / exception / degraded-call message). The decision
 * lives in `@poseidon/components` so the extension's sink makes the same one; only the transport
 * is this file's.
 */
export function reportSoftphoneDiagnostic(diagnostic: SoftphoneDiagnostic): void {
  const report = buildSoftphoneReport(diagnostic);
  if (report == null) return;
  switch (report.kind) {
    case 'breadcrumb':
      Sentry.addBreadcrumb({
        category: report.category,
        level: report.level,
        message: report.message,
        data: report.data,
      });
      return;
    case 'exception': {
      const error = new Error(report.message);
      error.name = report.name;
      Sentry.captureException(error, { tags: report.tags, extra: report.extra });
      return;
    }
    case 'message':
      Sentry.captureMessage(report.message, {
        level: report.level,
        tags: report.tags,
        extra: report.extra,
        fingerprint: report.fingerprint,
      });
      return;
  }
}
